import moment, { type Moment } from "moment";
import { addOsloDays } from "../../../common/procurement/osloDays";

const DEFAULT_QUESTION_DAYS_BEFORE_BID = 7;

// Mirrors SourcingEvent.questionDeadline in the BFF.
export const shortenedQuestionDeadline = (
  bidDeadline: Moment,
  questionDaysBeforeBid: number | null | undefined,
  invitedAt: Moment = moment(),
): Moment | null => {
  const usual = moment(addOsloDays(bidDeadline, -(questionDaysBeforeBid ?? DEFAULT_QUESTION_DAYS_BEFORE_BID)));
  if (!usual.isBefore(invitedAt.clone().add(24, "hours"))) return null;
  return moment(invitedAt.valueOf() + (bidDeadline.valueOf() - invitedAt.valueOf()) / 2).startOf("minute");
};
